import { Flame } from "lucide-react";
import { Button } from "@/components/ui/button";

export default function LoginPage() {
  const handleGoogleLogin = () => {
    const clientId = process.env.REACT_APP_GOOGLE_CLIENT_ID;
    if (!clientId) {
      alert("Google login is not configured. Please contact the administrator.");
      return;
    }
    const redirectUri = window.location.origin + '/auth/callback';
    const params = new URLSearchParams({
      client_id: clientId,
      redirect_uri: redirectUri,
      response_type: "code",
      scope: "openid email profile",
      access_type: "offline",
      prompt: "select_account",
    });
    window.location.href = `https://accounts.google.com/o/oauth2/v2/auth?${params.toString()}`;
  };

  return (
    <div className="min-h-screen bg-background flex items-center justify-center p-4" data-testid="login-page">
      <div className="w-full max-w-sm">
        {/* Logo */}
        <div className="flex flex-col items-center mb-10">
          <div className="w-14 h-14 rounded-sm bg-blue-500 flex items-center justify-center mb-4">
            <Flame className="w-8 h-8 text-white" />
          </div>
          <h1
            className="text-4xl font-bold tracking-tight uppercase text-foreground"
            style={{ fontFamily: 'Barlow Condensed, sans-serif' }}
          >
            GASFLOW PRO
          </h1>
          <p className="text-xs tracking-[0.3em] uppercase text-muted-foreground mt-1">
            Commercial Gas Engineering CRM
          </p>
        </div>

        {/* Login Card */}
        <div className="bg-card border border-white/5 rounded-sm p-8">
          <h2
            className="text-xl font-semibold tracking-tight mb-2 text-foreground"
            style={{ fontFamily: 'Barlow Condensed, sans-serif' }}
          >
            SIGN IN
          </h2>
          <p className="text-sm text-muted-foreground mb-8">
            Sign in with your Google account to access your pipeline.
          </p>

          <Button
            data-testid="google-login-btn"
            onClick={handleGoogleLogin}
            className="w-full h-12 bg-white hover:bg-gray-100 text-gray-900 rounded-sm font-medium text-sm flex items-center justify-center gap-3 transition-colors duration-150"
          >
            <svg width="18" height="18" viewBox="0 0 24 24">
              <path d="M22.56 12.25c0-.78-.07-1.53-.2-2.25H12v4.26h5.92a5.06 5.06 0 0 1-2.2 3.32v2.77h3.57c2.08-1.92 3.28-4.74 3.28-8.1z" fill="#4285F4"/>
              <path d="M12 23c2.97 0 5.46-.98 7.28-2.66l-3.57-2.77c-.98.66-2.23 1.06-3.71 1.06-2.86 0-5.29-1.93-6.16-4.53H2.18v2.84C3.99 20.53 7.7 23 12 23z" fill="#34A853"/>
              <path d="M5.84 14.09c-.22-.66-.35-1.36-.35-2.09s.13-1.43.35-2.09V7.07H2.18C1.43 8.55 1 10.22 1 12s.43 3.45 1.18 4.93l2.85-2.22.81-.62z" fill="#FBBC05"/>
              <path d="M12 5.38c1.62 0 3.06.56 4.21 1.64l3.15-3.15C17.45 2.09 14.97 1 12 1 7.7 1 3.99 3.47 2.18 7.07l3.66 2.84c.87-2.6 3.3-4.53 6.16-4.53z" fill="#EA4335"/>
            </svg>
            Continue with Google
          </Button>
        </div>

        <p className="text-center text-[10px] text-muted-foreground/50 mt-6 tracking-wider uppercase">
          Protected access &middot; Authorised users only
        </p>
      </div>
    </div>
  );
}
